/** Auto-generated at build time - do not edit */
export const APP_VERSION = "1.6539.0";
